import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/PrivacyPolicy.css';
import '../styles/DynamicPanel.css';

const PrivacyPolicy = ({ isOpen, onClose }) => {
  const { t, language } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="dynamic-panel">
      {/* Power Panel Container */}
      <div className="theme-power privacy-power-panel">

        {/* Power Headline */}
        <div className="privacy-power-headline">
          <div className="privacy-headline-left">
            <span className="privacy-headline-icon">🔒</span>
            <h2 className="privacy-headline-title">
              {language === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'}
            </h2>
          </div>
        </div>

        {/* Content Wrapper */}
        <div className="privacy-content-wrapper">
          {language === 'de' ? (
            <>
              <section className="privacy-section">
                <h3>🏢 Verantwortlicher</h3>
                <p>
                  <strong>MyBoki.Me</strong><br />
                  Benjamin Busch<br />
                  E-Mail: team@myboki.me
                </p>
              </section>

              <section className="privacy-section">
                <h3>📋 Allgemeine Informationen</h3>
                <p>
                  Diese Datenschutzerklärung erklärt, wie myboki.me Ihre personenbezogenen Daten 
                  verarbeitet und schützt. Wir nehmen den Schutz Ihrer Privatsphäre sehr ernst.
                </p>
              </section>

              <section className="privacy-section">
                <h3>💾 Welche Daten werden erhoben?</h3>
                <div className="data-list">
                  <h4>🔐 Authentifizierungsdaten:</h4>
                  <ul>
                    <li>E-Mail-Adresse (zur Kontenerstellung und Anmeldung)</li>
                    <li>Gehashte Passwörter (niemals im Klartext gespeichert)</li>
                    <li>Benutzername (optional)</li>
                    <li>Authentifizierungs-Token (dev-token-* für lokale Entwicklung)</li>
                  </ul>

                  <h4>📚 Bookmark-Daten:</h4>
                  <ul>
                    <li>URL der gespeicherten Lesezeichen</li>
                    <li>Titel und Beschreibung der Lesezeichen</li>
                    <li>Kategorien und Tags</li>
                    <li>Erstellungs- und Änderungsdatum</li>
                    <li>Favoriten-Status</li>
                  </ul>

                  <h4>🔧 Technische Daten:</h4>
                  <ul>
                    <li>Browser-Typ und -Version (nur zur Kompatibilität)</li>
                    <li>Betriebssystem (automatisch erkannt)</li>
                    <li>Spracheinstellungen</li>
                    <li>Theme-Präferenzen (Hell/Dunkel)</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>🎯 Zweck der Datenverarbeitung</h3>
                <ul>
                  <li><strong>Kontoverwaltung:</strong> Benutzerregistrierung und -authentifizierung</li>
                  <li><strong>Bookmark-Management:</strong> Speicherung und Synchronisation Ihrer Lesezeichen</li>
                  <li><strong>Multi-Device-Sync:</strong> Zugriff von verschiedenen Geräten</li>
                  <li><strong>Backup & Wiederherstellung:</strong> Schutz vor Datenverlust</li>
                  <li><strong>Import-Funktionalität:</strong> Chrome-Bookmark-Import</li>
                  <li><strong>Benutzerfreundlichkeit:</strong> Personalisierte Einstellungen</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>🏛️ Rechtsgrundlage (DSGVO)</h3>
                <ul>
                  <li><strong>Art. 6 Abs. 1 lit. b DSGVO:</strong> Vertragserfüllung (Bereitstellung der App-Funktionen)</li>
                  <li><strong>Art. 6 Abs. 1 lit. f DSGVO:</strong> Berechtigte Interessen (Sicherheit und Funktionalität)</li>
                  <li><strong>Art. 6 Abs. 1 lit. a DSGVO:</strong> Einwilligung (z.B. bei Sprachsteuerung)</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>💾 Datenspeicherung und -sicherheit</h3>
                <div className="security-info">
                  <h4>🔒 Lokale Speicherung:</h4>
                  <ul>
                    <li>Daten werden lokal in Ihrem Browser gespeichert (localStorage)</li>
                    <li>Automatische Backups zur Verhinderung von Datenverlust</li>
                    <li>Keine Übertragung an Dritte ohne Ihre Zustimmung</li>
                  </ul>

                  <h4>🌐 Backend-Speicherung:</h4>
                  <ul>
                    <li>PostgreSQL-Datenbank für Multi-Device-Synchronisation</li>
                    <li>Verschlüsselte Passwörter (bcrypt-Hashing)</li>
                    <li>Sichere Token-basierte Authentifizierung</li>
                    <li>HTTPS-Verschlüsselung für Datenübertragung</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>🔧 Verwendete Technologien</h3>
                <div className="tech-stack">
                  <h4>Frontend:</h4>
                  <ul>
                    <li><strong>React 19.1.1:</strong> Benutzeroberfläche</li>
                    <li><strong>localStorage:</strong> Lokale Datenspeicherung</li>
                    <li><strong>Web Speech API:</strong> Sprachsteuerung (nur mit Einwilligung)</li>
                    <li><strong>CSS3:</strong> Styling und Themes</li>
                  </ul>

                  <h4>Backend:</h4>
                  <ul>
                    <li><strong>Spring Boot 3.2:</strong> REST API</li>
                    <li><strong>PostgreSQL 15:</strong> Datenbankmanagement</li>
                    <li><strong>JWT/Token:</strong> Authentifizierung</li>
                    <li><strong>Docker:</strong> Containerisierung</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>⏱️ Speicherdauer</h3>
                <ul>
                  <li><strong>Kontodaten:</strong> Bis zur Kontolöschung</li>
                  <li><strong>Bookmark-Daten:</strong> Bis zur manuellen Löschung</li>
                  <li><strong>Lokale Backups:</strong> 30 Tage (automatisch)</li>
                  <li><strong>Authentifizierungs-Token:</strong> 24 Stunden (erneuerbar)</li>
                  <li><strong>Spracheinstellungen:</strong> Dauerhaft (bis zur Änderung)</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>👥 Datenweitergabe</h3>
                <p>
                  <strong>Keine Weitergabe an Dritte!</strong> Ihre Daten werden ausschließlich für die 
                  App-Funktionalität verwendet und nicht an Dritte verkauft, vermietet oder weitergegeben.
                </p>
                
                <h4>🔗 Externe Services:</h4>
                <ul>
                  <li><strong>Google Favicons:</strong> Für Website-Icons (nur URLs, keine persönlichen Daten)</li>
                  <li><strong>FontAwesome CDN:</strong> Für App-Icons (keine Datenübertragung)</li>
                  <li><strong>GitHub:</strong> Quellcode-Repository (keine Nutzerdaten)</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>⚖️ Ihre Rechte nach DSGVO</h3>
                <ul>
                  <li><strong>Art. 15 DSGVO:</strong> Auskunftsrecht über gespeicherte Daten</li>
                  <li><strong>Art. 16 DSGVO:</strong> Recht auf Berichtigung fehlerhafter Daten</li>
                  <li><strong>Art. 17 DSGVO:</strong> Recht auf Löschung ("Recht auf Vergessenwerden")</li>
                  <li><strong>Art. 18 DSGVO:</strong> Recht auf Einschränkung der Verarbeitung</li>
                  <li><strong>Art. 20 DSGVO:</strong> Recht auf Datenportabilität</li>
                  <li><strong>Art. 21 DSGVO:</strong> Widerspruchsrecht</li>
                  <li><strong>Art. 7 Abs. 3 DSGVO:</strong> Widerruf von Einwilligungen</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>🎤 Besondere Hinweise zur Sprachsteuerung</h3>
                <p>
                  Die Sprachsteuerung ist eine optionale Funktion, die nur mit Ihrer ausdrücklichen 
                  Einwilligung aktiviert wird:
                </p>
                <ul>
                  <li>Sprachbefehle werden lokal verarbeitet (Web Speech API)</li>
                  <li>Keine Aufzeichnung oder Speicherung von Sprachdaten</li>
                  <li>Jederzeit deaktivierbar über das Hamburger-Menü</li>
                  <li>Einwilligung kann jederzeit widerrufen werden</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>🔄 Änderungen der Datenschutzerklärung</h3>
                <p>
                  Diese Datenschutzerklärung kann bei Änderungen der App oder rechtlichen 
                  Anforderungen aktualisiert werden. Sie werden über wesentliche Änderungen informiert.
                </p>
                <p><strong>Letzte Aktualisierung:</strong> Januar 2026 (Version 0.6.8)</p>
              </section>

              <section className="privacy-section">
                <h3>📧 Kontakt & Beschwerden</h3>
                <p>
                  <strong>Datenschutzbeauftragter:</strong><br />
                  MyBoki.Me<br />
                  E-Mail: team@myboki.me
                </p>
                <p>
                  <strong>Aufsichtsbehörde:</strong><br />
                  Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die 
                  Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
                </p>
              </section>
            </>
          ) : (
            <>
              <section className="privacy-section">
                <h3>🏢 Data Controller</h3>
                <p>
                  <strong>MyBoki.Me</strong><br />
                  Benjamin Busch<br />
                  Email: team@myboki.me
                </p>
              </section>

              <section className="privacy-section">
                <h3>📋 General Information</h3>
                <p>
                  This privacy policy explains how myboki.me processes and protects your 
                  personal data. We take the protection of your privacy very seriously.
                </p>
              </section>

              <section className="privacy-section">
                <h3>💾 What Data is Collected?</h3>
                <div className="data-list">
                  <h4>🔐 Authentication Data:</h4>
                  <ul>
                    <li>Email address (for account creation and login)</li>
                    <li>Hashed passwords (never stored in plain text)</li>
                    <li>Username (optional)</li>
                    <li>Authentication tokens (dev-token-* for local development)</li>
                  </ul>

                  <h4>📚 Bookmark Data:</h4>
                  <ul>
                    <li>URLs of saved bookmarks</li>
                    <li>Title and description of bookmarks</li>
                    <li>Categories and tags</li>
                    <li>Creation and modification dates</li>
                    <li>Favorite status</li>
                  </ul>

                  <h4>🔧 Technical Data:</h4>
                  <ul>
                    <li>Browser type and version (for compatibility only)</li>
                    <li>Operating system (automatically detected)</li>
                    <li>Language preferences</li>
                    <li>Theme preferences (Light/Dark)</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>🎯 Purpose of Data Processing</h3>
                <ul>
                  <li><strong>Account Management:</strong> User registration and authentication</li>
                  <li><strong>Bookmark Management:</strong> Storage and synchronization of your bookmarks</li>
                  <li><strong>Multi-Device Sync:</strong> Access from different devices</li>
                  <li><strong>Backup & Recovery:</strong> Protection against data loss</li>
                  <li><strong>Import Function:</strong> Chrome bookmark import</li>
                  <li><strong>User Experience:</strong> Personalized settings</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>🏛️ Legal Basis (GDPR)</h3>
                <ul>
                  <li><strong>Art. 6(1)(b) GDPR:</strong> Contract performance (providing app functions)</li>
                  <li><strong>Art. 6(1)(f) GDPR:</strong> Legitimate interests (security and functionality)</li>
                  <li><strong>Art. 6(1)(a) GDPR:</strong> Consent (e.g., for voice control)</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>💾 Data Storage and Security</h3>
                <div className="security-info">
                  <h4>🔒 Local Storage:</h4>
                  <ul>
                    <li>Data is stored locally in your browser (localStorage)</li>
                    <li>Automatic backups to prevent data loss</li>
                    <li>No transmission to third parties without your consent</li>
                  </ul>

                  <h4>🌐 Backend Storage:</h4>
                  <ul>
                    <li>PostgreSQL database for multi-device synchronization</li>
                    <li>Encrypted passwords (bcrypt hashing)</li>
                    <li>Secure token-based authentication</li>
                    <li>HTTPS encryption for data transmission</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>🔧 Technologies Used</h3>
                <div className="tech-stack">
                  <h4>Frontend:</h4>
                  <ul>
                    <li><strong>React 19.1.1:</strong> User interface</li>
                    <li><strong>localStorage:</strong> Local data storage</li>
                    <li><strong>Web Speech API:</strong> Voice control (with consent only)</li>
                    <li><strong>CSS3:</strong> Styling and themes</li>
                  </ul>

                  <h4>Backend:</h4>
                  <ul>
                    <li><strong>Spring Boot 3.2:</strong> REST API</li>
                    <li><strong>PostgreSQL 15:</strong> Database management</li>
                    <li><strong>JWT/Token:</strong> Authentication</li>
                    <li><strong>Docker:</strong> Containerization</li>
                  </ul>
                </div>
              </section>

              <section className="privacy-section">
                <h3>⏱️ Data Retention</h3>
                <ul>
                  <li><strong>Account Data:</strong> Until account deletion</li>
                  <li><strong>Bookmark Data:</strong> Until manual deletion</li>
                  <li><strong>Local Backups:</strong> 30 days (automatic)</li>
                  <li><strong>Authentication Tokens:</strong> 24 hours (renewable)</li>
                  <li><strong>Language Settings:</strong> Permanently (until changed)</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>👥 Data Sharing</h3>
                <p>
                  <strong>No sharing with third parties!</strong> Your data is used exclusively for 
                  app functionality and is not sold, rented, or shared with third parties.
                </p>
                
                <h4>🔗 External Services:</h4>
                <ul>
                  <li><strong>Google Favicons:</strong> For website icons (URLs only, no personal data)</li>
                  <li><strong>FontAwesome CDN:</strong> For app icons (no data transmission)</li>
                  <li><strong>GitHub:</strong> Source code repository (no user data)</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>⚖️ Your Rights under GDPR</h3>
                <ul>
                  <li><strong>Art. 15 GDPR:</strong> Right to information about stored data</li>
                  <li><strong>Art. 16 GDPR:</strong> Right to rectification of incorrect data</li>
                  <li><strong>Art. 17 GDPR:</strong> Right to erasure ("Right to be forgotten")</li>
                  <li><strong>Art. 18 GDPR:</strong> Right to restriction of processing</li>
                  <li><strong>Art. 20 GDPR:</strong> Right to data portability</li>
                  <li><strong>Art. 21 GDPR:</strong> Right to object</li>
                  <li><strong>Art. 7(3) GDPR:</strong> Withdrawal of consent</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>🎤 Special Notes on Voice Control</h3>
                <p>
                  Voice control is an optional feature that is only activated with your explicit consent:
                </p>
                <ul>
                  <li>Voice commands are processed locally (Web Speech API)</li>
                  <li>No recording or storage of voice data</li>
                  <li>Can be deactivated at any time via the hamburger menu</li>
                  <li>Consent can be withdrawn at any time</li>
                </ul>
              </section>

              <section className="privacy-section">
                <h3>🔄 Changes to Privacy Policy</h3>
                <p>
                  This privacy policy may be updated in case of changes to the app or legal requirements. 
                  You will be informed about significant changes.
                </p>
                <p><strong>Last Updated:</strong> January 2026 (Version 0.6.8)</p>
              </section>

              <section className="privacy-section">
                <h3>📧 Contact & Complaints</h3>
                <p>
                  <strong>Data Protection Officer:</strong><br />
                  MyBoki.Me<br />
                  Email: team@myboki.me
                </p>
                <p>
                  <strong>Supervisory Authority:</strong><br />
                  You have the right to lodge a complaint with a data protection supervisory authority 
                  about the processing of your personal data.
                </p>
              </section>
            </>
          )}
        </div>
        {/* End Content Wrapper */}

      </div>
      {/* End Power Panel */}
    </div>
  );
};

export default PrivacyPolicy;